<template>
  <div class="no-performance-item">
    <div class="icon"></div>
    <div class="text">{{ message }}</div>
  </div>
</template>
<script>
export default {
  name: 'no-data',
  props: {
    message: { type: String, default: '', required: true }
  }
};
</script>
<style type="scss" scoped>
.no-performance-item {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .text {
    color: #8a8f99;
    font-family:$lego__font-family;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
  }
  .icon {
    margin-top: 24px;
    background-image: url('../../../assets/img/scmp/img_no_performace_item.png');
    display: block;
    width: 180px;
    height: 140px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 180px 134px;
  }
}
</style>
